import React from 'react'
import { useData } from '../context/DataContext'

interface IButtonProps {
  label: string
  isSelected: boolean
  onClick: () => void
  reversed?: boolean
  style?: string
}

const NavButton: React.FC<IButtonProps> = ({
  label,
  isSelected,
  reversed,
  style,
  onClick,
}: IButtonProps) => {
  const { selectedVideo } = useData()
  const arrow = `after:absolute after:w-2 after:h-2 after:border-t-2 after:border-l-2 after:border-gold ${
    reversed ?? false ? 'after:rotate-[135deg]' : 'after:rotate-[-45deg]'
  }`

  return (
    <button
      className={`stat-button-link group w-full flex items-center justify-center p-2 border-[1px] lg:border-2 border-gold duration-100 transition-colors bg-black-0.3 hover:bg-gold-hover active:bg-gray-light-press font-header uppercase font-bold text-white tracking-widest text-sm 2xl:text-base ${
        style != null ? style : ''
      } ${reversed ?? false ? 'flex-row-reverse' : ''}
      ${isSelected ? 'opacity-0' : 'opacity-100'}`}
      onClick={onClick}
      disabled={isSelected}
      data-dtm={selectedVideo?.key}
    >
      <div
        className={`relative w-2 h-[7px] ${
          reversed ?? false
            ? 'group-hover:animate-slideRight'
            : 'group-hover:animate-slideLeft'
        } ${arrow}`}
      ></div>
      <div
        className={`${reversed ?? false ? 'pr-1 2xl:pr-2' : 'pl-2 2xl:pl-4'}`}
      >
        {label}
      </div>
    </button>
  )
}

export default NavButton

// px-4 lg:px-1 flex items-center transition-opacity duration-300

// <div
//         className={`h-[1px] lg:h-[2px] bg-gold transition-flex-grow duration-[250ms] delay-200 ${
//           isSelected ? 'grow' : 'grow-[0.0000001]'
//         } ${
//           reversed ?? false
//             ? 'order-2 mr-1 md:mr-[6px] lg:mr-2'
//             : 'ml-1 md:ml-[6px] lg:ml-2'
//         }`}
//       />
